import { Button } from "@chakra-ui/react";
import { FC } from "react";
import { Info } from "../Info";
import { AboutUserWrapper } from "./styles";

export const UserInfo: FC = () => (
  <AboutUserWrapper>
    <Info />
    <Button>Отменить бронь</Button>
  </AboutUserWrapper>
);
